import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { GetOrders, Alerts } from '../../../helpers';
import { Card } from 'react-bootstrap';
import ThemeModal from '../../../components/cmp/ThemeModal';
import { Link } from 'react-router-dom';
const Refund = () => {
    const [isLoading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    const [refunds, setRefunds] = useState({});
    const [vatChecked, setVatChecked] = useState(true);
    const [vatAmount, setVatAmount] = useState(0);
    const [shippingChecked, setShippingChecked] = useState(true);
    const [shippingAmount, setShippingAmount] = useState(0);
    const [refundReason, setRefundReason] = useState('');
    const [refundLoading, setRefundLoading] = useState(false);
    const [isShowSuccess, setShowSuccess] = useState(false);
    const [refundResp, setRespRefund] = useState(null);
    const [refundedAmount, setRefundAmount] = useState(0);
    const { orderid } = useParams();
    const contentRef = useRef(null);

    const getOrder = async (orderid) => {
        const resp = await GetOrders.getSingleOrders(orderid);
        console.log(resp);
        if (resp && resp.status) {
            setOrder(resp.order);
            calculateRefund(resp.order);
            setShippingAmount(parseFloat(resp.order.delivery_charge));
            setLoading(false);
        }
    };


    const calculateRefund = (order) =>{
        const totalRefund = order.refunds.reduce((sum, refund) => sum + parseFloat(refund.amount), 0);
        setRefundAmount(totalRefund);
    }

    useEffect(() => {
        getOrder(orderid);
    }, [orderid]);

    const getDateTime = (dataTime) => {
        const dateObj = new Date(dataTime);
        const date = dateObj.toLocaleDateString('en-GB', { timeZone: 'Europe/London' });
        const time = dateObj.toLocaleTimeString('en-GB', {
            timeZone: 'Europe/London',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
        return `${date} - ${time}`;
    };



    // Build refund summary
    const getSummary = () => {
        if (!order) return [];
        return order.ordered_items
            .map((item, i) => {
                const r = refunds[i];
                if (!r || r.quantity === 0) return null;
                return {
                    orderId: order.id,
                    orderItemId: item.id,
                    productId: item.product_id || item.variation_product_id,
                    title: item.variation_product.variation_content.title,
                    refundQuantity: r.quantity,
                    refundAmount: r.quantity * item.unit_price,
                };
            })
            .filter(Boolean);
    };

    const subtotal = getSummary().reduce((sum, item) => sum + item.refundAmount, 0);
    const vatValue = vatChecked ? (subtotal * 0.20) : 0;
    const shippingValue = shippingChecked ? parseFloat(shippingAmount) || 0 : 0;
    const grandTotal = subtotal + vatValue + shippingValue;


    const handleRefund = async (refundProducts) => {
        setRefundLoading(true);
        const reqData = {
            orderId: order.order_number,
            refundProducts: refundProducts.items,
            isVat: vatChecked,
            isShipping: shippingChecked,
            refund_reason: refundReason
        }
        const resp = await GetOrders.createOrderRefund(reqData);
        setRefundLoading(false);

        if (!resp.success) {
            Alerts.alertMessage(resp.message, "top-right", "error");
        } else {
            Alerts.alertMessage("Refund created successfully!", "top-right", "success");
            setRespRefund(resp.data.refund);
            setShowSuccess(true);
            console.log("Refund Data:", resp.data);
        }
    }

    const handleCloseSuccess = () =>{
        setShowSuccess(false);
        setShowSuccess(false);
        getOrder(orderid);
    }
    const statusClasses = {
          Processing: "bg-warning",
          Processed: "bg-info",
          Shipped: "bg-primary",
          Out_for_delivery: "bg-secondary",
          Delivered: "bg-success",
          Canceled: "bg-danger",
          Pending: "bg-warning",
          Refunded: "bg-dark",
          Partially_Refunded: "bg-secondary",
          Refund_Initiated: "bg-info",
    };


  const excludeOrderStatus = ["Refunded", "Partially_Refunded", "Refund_Initiated"];

    return (
        <div className='singleOrderWrapper' ref={contentRef}>
            {isLoading ? (
                <div className='loader'>
                    <img src='/images/loader.gif' alt='loader' />
                </div>
            ) : (
                <div className='container-fluid'>
                    <div className='orderHeader' style={{ padding: '10px 20px' }}>
                        <div className='orderHeaderLeft'>
                            <div className='orderStatus'>
                                <span className='orderNumber'>#{order.order_number}</span>
                                <h4>Refund</h4>
                            </div>
                            <div className='orderDate'>{getDateTime(order.createdAt)} from Triplast</div>
                        </div>
                    </div>

                    <div className='orderDetails' style={{ padding: '0px 20px 50px' }}>
                        <div className='row'>
                            <div className='col-md-8'>
                                <Card style={{ marginTop: 30 }}>
                                    <Card.Header style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 500, fontSize: 18 }}>
                                        Ordered Product
                                    {!excludeOrderStatus.includes(order.order_status) && (
                                     <div className={`badge ${statusClasses[order.order_status] || ""}`}>
                                       {order.order_status}
                                     </div>
                                     )}
                                    </Card.Header>
                                    <Card.Body>
                                        <table className='table table-ft-15'>
                                            <thead>
                                                <tr>
                                                    <th colSpan={2}>Product Name</th>
                                                    <th className='text-center'>Refund Qty</th>
                                                    <th className='text-center'>Refund Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {order.ordered_items.map((item, i) => {
                                                    const r = refunds[i] || { quantity: 0 };
                                                        
                                                    if(parseInt(item.quantity) - parseInt(item.refunded_quantity) === 0){
                                                        return null;
                                                    } 

                                                    if(item.is_bulk_order){
                                                        return null;
                                                    }
                                                        
                                                    return (
                                                       
                                                        <tr key={i}>
                                                            <td>
                                                                {item.pro_sku !== null ? (
                                                                    <img src={item.product.product_thumbnail.path} alt='image' width={50} />
                                                                ) : item.variation_product?.variation_galleries?.length > 0 ? (
                                                                    <img src={item.variation_product.variation_galleries[0].media_file.path} alt='image' width={50} />
                                                                ) : (
                                                                    <img src={item.variation_product.variation_main_image.path} alt='image' width={50} />
                                                                )}
                                                            </td>
                                                            <td style={{ maxWidth: 300, fontSize: 12 }}>
                                                                {item.variation_product.variation_content.title}
                                                                <br /> <strong>SKU :</strong> {item.pro_sku || item.var_sku}
                                                                <br /> <strong>£ {item.unit_price} × {item.quantity}</strong>
                                                                 <br/>
                                                             {item.refunded_quantity === 0 ? null : item.refunded_quantity === item.quantity ?  <div className={`badge bg-dark mb-3`}>Refunded</div> :  <div className={`badge bg-secondary mb-3`}>Partially Refunded</div>} 
                                                            </td>
                                                            <td>
                                                                <div className="input-group justify-content-center">
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        max={(parseInt(item.quantity) - parseInt(item.refunded_quantity))}
                                                                        value={r.quantity}
                                                                        className="form-control quantity-input"
                                                                        onChange={(e) => {
                                                                            let q = parseInt(e.target.value) || 0;
                                                                            if (q > (parseInt(item.quantity) - parseInt(item.refunded_quantity))) 
                                                                                q = parseInt(item.quantity) - parseInt(item.refunded_quantity)
                                                                         
                                                                            //  console.log(parseInt(item.quantity) - parseInt(item.refunded_quantity));
                                                                            setRefunds(prev => ({
                                                                                ...prev,
                                                                                [i]: { quantity: q }
                                                                            }));
                                                                        }}
                                                                    />
                                                                    <span className="input-group-text">/ {item.quantity - item.refunded_quantity }</span>
                                                                </div>
                                                            </td>
                                                            <td className="text-right">
                                                                £ {(r.quantity * item.unit_price).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </Card.Body>
                                </Card>

                                <Card style={{ marginTop: 30 }}>

                                    <Card.Body>
                                        <div className='mb-20' style={{ borderBottom: '1px solid #dcdcdc' }}>
                                            <h5 style={{ fontSize: 18 }}> Refund VAT</h5>
                                            <div className='vatBox'>
                                                <div className='vatCheck'>
                                                    <input
                                                        type='checkbox'
                                                        checked={vatChecked}
                                                        onChange={(e) => setVatChecked(e.target.checked)}
                                                    />
                                                    VAT (20%)
                                                </div>
                                                <div className="input-group mb-3 vatInput">
                                                    <span className="input-group-text">£</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={vatValue.toFixed(2)}
                                                        onChange={(e) => setVatAmount(e.target.value)}
                                                        disabled={!vatChecked}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mb-20' style={{ borderBottom: '1px solid #dcdcdc' }}>
                                            <h5 style={{ fontSize: 18 }}> Refund Shipping</h5>
                                            <div className='vatBox'>
                                                <div className='vatCheck'>
                                                    <input
                                                        type='checkbox'
                                                        checked={shippingChecked}
                                                        onChange={(e) => setShippingChecked(e.target.checked)}
                                                    />
                                                    Standard Shipping
                                                </div>
                                                <div className="input-group mb-3 vatInput">
                                                    <span className="input-group-text">£</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={shippingAmount}
                                                        onChange={(e) => setShippingAmount(e.target.value)}
                                                        disabled={!shippingChecked}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mb-20'>
                                            <h5 style={{ fontSize: 18, marginBottom: 15 }}> Reason</h5>
                                            <div className='vatBox'>
                                                <textarea className='form-control' value={refundReason} onChange={(e) => setRefundReason(e.target.value)}></textarea>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </div>


                            <div className='col-md-4'>
                                <Card style={{ marginTop: 30, fontWeight: 500, marginBottom: 50 }}>
                                    <Card.Header style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 500, fontSize: 18 }}>
                                        Summary
                                    </Card.Header>
                                    <Card.Body>
                                        <div className='summary-box'>
                                            {
                                                subtotal === 0 ? <p>No items selected</p> : <ul>
                                                    <li><span>Subtotal </span> <span>£{subtotal.toFixed(2)}</span></li>
                                                    {vatChecked && (
                                                        <li><span>VAT (20%) </span> <span>£{vatValue.toFixed(2)}</span></li>
                                                    )}
                                                    {shippingChecked && (
                                                        <li><span>Shipping  </span> <span>£{shippingValue.toFixed(2)}</span></li>
                                                    )}
                                                    <li><span>Grand Total </span> <span>£{grandTotal.toFixed(2)}</span></li>
                                                </ul>
                                            }

                                        </div>


                                        <div className='refund-box'>
                                            <h5>Refund amount</h5>

                                            <p>£ {parseFloat(order.total_amount) - refundedAmount} available for refund</p>
                                            <div className="form-check d-flex align-items-center gap-2">
                                                <input className="form-check-input" type="checkbox" id="checkDefault" style={{ minHeight: 'auto' }} />
                                                <label className="form-check-label" htmlFor="checkDefault">
                                                    Send notification once refund is finalized
                                                </label>
                                            </div>
                                            <button
                                                type='button'
                                                className='btn btn-primary btn-block btn-sm mt-2'
                                                disabled={grandTotal <= 0 || refundLoading || subtotal === 0}
                                                onClick={() => {
                                                    const payload = {
                                                        items: getSummary(),
                                                        subtotal,
                                                        vat: vatChecked ? parseFloat(vatAmount) || 0 : 0,
                                                        shipping: shippingChecked ? parseFloat(shippingAmount) || 0 : 0,
                                                        grandTotal
                                                    };
                                                    handleRefund(payload);
                                                }}

                                            >
                                               

                                                  {
                                                    refundLoading ? 'Please wait..' : `Refund ${subtotal !== 0 ? ` £${grandTotal.toFixed(2)}` : ''}`
                                                }

                                            </button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                    </div>
                   {
                    refundResp && refundResp !== null &&  <ThemeModal show={isShowSuccess} handleHide={() => setShowSuccess(false)} title="" isHeader={false} centered={true}>
                        <div className='success-box'>
                            <div className='success-icon'>
                                <img src='/images/correct.png' alt='' />
                            </div>

                            <h3>Order refund initiated successfully !</h3>

                            <p>Refund ID - {refundResp.refund_id}</p>
                        </div>
                        <div className='success-actions'>
                            <Link to={'/app/orders/view'} className='btn btn-info btn-sm'>View Orders</Link>
                            <button className='btn btn-danger btn-sm' onClick={handleCloseSuccess}>Close</button>
                        </div>
                    </ThemeModal>
                   }
                   
                </div>
            )}
        </div>
    )
};

export default Refund;
